import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchDailyMatchesRequest } from '@/api/matches';
import { removeTimezone } from '@/utils';
import {
  fetchDailyMatches,
  setDailyMatches,
  setSelectedDate,
  tryFetchDailyMatches,
} from '../actions';
import { currentDailyMatches } from '../selectors';

const handleDateChangeEpic: Epic = (action$) =>
  action$.pipe(
    filter(setSelectedDate.match),
    map(({ payload }) => {
      if (payload) {
        return tryFetchDailyMatches(payload);
      }

      return { type: 'NO_DATE_SELECTED' };
    }),
  );

const tryFetchDailyMatchesEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchDailyMatches.match),
    withLatestFrom(state$),
    map(([{ payload }, state]) => {
      const currentMatches = currentDailyMatches(state);

      if (currentMatches) {
        return { type: 'DAILY_MATCHES_ALREADY_FETCHED' };
      }

      return fetchDailyMatches(payload);
    }),
  );

const fetchDailyMatchesEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDailyMatches.match),
    request(
      ({ payload }) => fetchDailyMatchesRequest(removeTimezone(payload)),
      fetchDailyMatches,
    ),
  );

const fetchDailyMatchesSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDailyMatches.succeeded.match),
    map(({ payload: { data, originalData } }) =>
      setDailyMatches({
        matches: data,
        selectedDate: originalData,
      }),
    ),
  );

export default combineEpics(
  handleDateChangeEpic,
  tryFetchDailyMatchesEpic,
  fetchDailyMatchesEpic,
  fetchDailyMatchesSucceededEpic,
);
